import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
const availableScores = [1, 2, 3, 4, 5];
const CustomerEffortScore = props => {
  const {
    onSelect
  } = props;
  const {
    t
  } = useTranslation();
  const [currentlySelectedScore, setCurrentlySelectedScore] = React.useState(3);
  const [currentlyHoveredScore, setCurrentlyHoveredScore] = React.useState(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "star-rating"
  }, /*#__PURE__*/React.createElement("span", null, t('customer_effort_score.labels.bad')), /*#__PURE__*/React.createElement("div", {
    className: "input-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "br-wrapper br-theme-css-stars"
  }, /*#__PURE__*/React.createElement("div", {
    className: "br-widget"
  }, availableScores.map(score => {
    const isCurrentlySelected = currentlySelectedScore === score;
    const hasHighlightByHover = currentlyHoveredScore && currentlyHoveredScore >= score;
    const hasHighlightBySelection = currentlySelectedScore >= score;
    const classes = c({
      'br-current': isCurrentlySelected,
      'br-selected': currentlyHoveredScore ? hasHighlightByHover : hasHighlightBySelection
    });
    return (
      /*#__PURE__*/
      /**
        * @todo: accessibility for this component is currently deeply unsatisfactory.
        * The "aria-current" attribute below doesn't do much in actuality to make
        * this component accessible. Consider as well that the anchors act like buttons,
        * but aren't marked up to as such.
        */
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      React.createElement("a", {
        href: "#",
        className: classes,
        "aria-current": isCurrentlySelected,
        onClick: e => {
          e.preventDefault();
          setCurrentlySelectedScore(score);
          onSelect(score);
        },
        onMouseEnter: () => {
          setCurrentlyHoveredScore(score);
        },
        onMouseLeave: () => {
          setCurrentlyHoveredScore(null);
        }
      }, t("customer_effort_score.scores.".concat(score)))
    );
  })))), /*#__PURE__*/React.createElement("span", null, t('customer_effort_score.labels.good')));
};
export default CustomerEffortScore;